export const COUNTRIES = "COUNTRIES";
export const COUNTRIES_SUCCESS = "COUNTRIES_SUCCESS";
export const COUNTRIES_ERROR = "COUNTRIES_ERROR";
export const COUNTRIES_CLEAR_DATA = "COUNTRIES_CLEAR_DATA";
